// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__XBj3d","container":"styles_container__15-0P","visible":"styles_visible__CEPfl"};